import request from "../utils/request";

export async function checkForPin(payload) {
  return request.post("SelfService/CheckForPin", payload);
}
export async function changePassword(payload){
  return request.post("cart/ChangePassword",payload);
}
export async function updateEmail(payload){
  console.log(payload);
  return request.put("User/UpdateEmail",payload);
}
export async function reloadProductCache(){
  return request.get("Sale/ReloadProductCache");
}
export async function completePayment(cart) {

  return new Promise((resolve, reject) => {
    request.post("cart/place-order",cart).then(response => {
      if (response.status != 200) {
        const msg =
          (response.data && response.data.message) || `HTTP ${response.status}`;
        reject(new Error(msg));
        return;
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}

/** Ödeme/POS'a gönderilmeden önce sepeti kanonik fiyat listesine karşı denetler. Sipariş oluşturmaz. */
export async function validateCartPrice(cart) {
  return request.post("cart/validate-price", cart);
}

export async function ReduceFromWallet(qrCode,amount) {

  let payload = {
    qrCode : qrCode,
    amount : amount
  }
  return await request.post("cart/pay",payload);
}

export async function fetchLastBillId() {
  return new Promise((resolve, reject) => {
    request.get("cart/GetLastBillId").then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}
export async function mobileOrder(){
  return (await request.get("Sale/mobile-order")).data;
}
export async function mobileOrderChangeStatus(payload){
  return (await request.put("Sale/mobile-order",payload)).data;
}
export async function qrCodeRead(qrCode){
  return (await request.get("Sale/qr-code?qrCode="+qrCode)).data;
}

export async function mobileOrderCount(){
  return (await request.get('Sale/mobile-order-quantity')).data;
}
